import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '../styles';
import { TickIcon } from '../icons';
const useStyles = makeStyles(({ palette, spacing }) => ({
    root: {
        cursor: ({ disabled }) => (disabled ? 'default' : 'pointer'),
        position: 'relative',
        color: 'white',
        margin: ({ nomargin }) => (nomargin ? '' : spacing(0.5, 1)),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: spacing(3.25),
        height: spacing(3.25),
        borderRadius: '3px',
        '&:hover': {
            backgroundColor: ({ disabled }) => disabled ? '' : `${palette.secondary.main}25`,
        },
    },
    input: {
        appearance: 'none',
        cursor: 'pointer',
        outline: 'none',
        width: spacing(2),
        height: spacing(2),
        minWidth: spacing(2),
        minHeight: spacing(2),
        borderRadius: '3px',
        border: `2px solid ${palette.secondary.main}`,
        '&:disabled': {
            cursor: 'default',
            borderColor: palette.action.disabled,
            '&:hover': {
                borderColor: palette.action.disabled,
            },
        },
        '&:checked': {
            backgroundColor: palette.secondary.main,
            color: 'white',
        },
    },
}));
function Checkbox({ id, checked = false, className, disabled = false, disableMargin = false, onChange, required = false, }) {
    const classes = useStyles({ nomargin: disableMargin, disabled });
    return (React.createElement("span", { onClick: onChange, className: classNames(classes.root, className) },
        React.createElement("input", { id: id, readOnly: true, checked: checked, required: required, disabled: disabled, type: "checkbox", className: classes.input }),
        React.createElement(TickIcon, { style: {
                position: 'absolute',
                top: 8,
                left: 7,
                height: 12,
                width: 12,
                fontSize: 14,
                color: 'inherit',
                display: checked ? 'block' : 'none',
                pointerEvents: 'none',
            } })));
}
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map